import { render, staticRenderFns } from "./ListEosWholesales.vue?vue&type=template&id=008ebdae&scoped=true&"
import script from "./ListEosWholesales.vue?vue&type=script&lang=ts&"
export * from "./ListEosWholesales.vue?vue&type=script&lang=ts&"
import style0 from "./ListEosWholesales.vue?vue&type=style&index=0&id=008ebdae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ebdae",
  null
  
)

export default component.exports